import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { makeStyles } from "@mui/styles";
import Colors from "../theme/colors.json";

const useStyles = makeStyles((theme) => ({
  commonBtnStyles: {
    background: Colors.WHITE_BACKGROUND,
    textTransform: "capitalize",
  },
}));

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ConfirmationDialog(props) {
  const classes = useStyles();
  const { open, setOpen, title, content, handleYes, handleNo } = props;

  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleNo()}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className={classes.commonBtnStyles}
            variant="outlined"
            color="primary"
            onClick={() => handleYes()}
          >
            Yes
          </Button>
          <Button
            className={classes.commonBtnStyles}
            variant="outlined"
            color="primary"
            onClick={() => handleNo()}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
